module.exports = __webpack_public_path__ + "img/sliders_2-01.cbff0e89.png";